// extracted by mini-css-extract-plugin
module.exports = {"permitTable":"Registrations_permitTable__12SiS","header":"Registrations_header__EeECj"};